import axios from "axios";
import React, { useState, useEffect } from "react";
import CreaEquipoAutoevaluacion from "./CreaEquipos/CreaEquipoAutoevaluacion";
import Cookies from "universal-cookie";
import DequipoCirugiaAutoevaluacion from "../../EliminaEquipos/DequipoAutoevaluacion";

function EquipoAutoevaluacion(props) {
  const cookies = new Cookies();
  const [list, setList] = useState([]);

  const url = window.location.href;
  const partesURL = url.split("/");
  const nombreRuta = partesURL[partesURL.indexOf("#") + 1];

  // 🔹 GET CENTRALIZADO
  const obtenerEquipos = () => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoAutoevaluacionPorSolicitudId?SolicitudId=" +
        props.idSolicitud,
    })
      .then((res) => setList(res.data))
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    obtenerEquipos();
  }, [props.idSolicitud]);

  return (
    <div className="container">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">
            1. EQUIPO DE AUTOEVALUACIÓN HOSPITALARIO
          </h6>
        </div>

        <div className="card-body">
          {cookies.get("tipo_Usuario") == 2 &&
            nombreRuta === "ProcesoAutoevaluacion" && (
              <CreaEquipoAutoevaluacion
                idSolicitud={props.idSolicitud}
                onCreated={obtenerEquipos} // ⬅️ CLAVE
              />
            )}

          <div className="table-responsive mt-3">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Nombre</th>
                  <th>Servicio</th>
                  <th>Cargo</th>
                  <th>Líder</th>
                  {nombreRuta === "ProcesoAutoevaluacion" && <th>Eliminar</th>}
                </tr>
              </thead>

              <tbody>
                {list.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No hay registros
                    </td>
                  </tr>
                ) : (
                  list.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.nombre}</td>
                      <td>{item.servicio}</td>
                      <td>{item.cargo}</td>
                      <td>{item.lider}</td>
                      {nombreRuta === "ProcesoAutoevaluacion" && (
                        <td>
                          <DequipoCirugiaAutoevaluacion
                            id={item.id}
                            onDeleted={obtenerEquipos}
                          />
                        </td>
                      )}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EquipoAutoevaluacion;
